module.exports = __webpack_public_path__ + "static/scale-model-of-the-gulch-|-nashville-in-nashville-tennessee-e5dc83e0ad59aad148d7e24b68daee1a.png";